import React from "react";
import ContentModerationView from "@/components/contentModeration/ContentModerationView";
import { breadcrumb_key } from "@/constants/translation/common.translation";
import { contentModeration } from "@/libs/routes";

/**
 * Content Moderation > Activities: basic details of one item with Deactivate / Reactivate / Delete.
 */
const ActivitiesModerationView = () => (
  <ContentModerationView sectionKey="activities" />
);

ActivitiesModerationView.breadCrumbArray = [
  {
    name: breadcrumb_key.contentModeration.activities.list,
    pathname: contentModeration.activities.list,
    active: false,
  },
  {
    name: breadcrumb_key.contentModeration.activities.view,
    pathname: "",
    active: true,
  },
];

export default ActivitiesModerationView;
